import { PremiumType } from '@app/domain/model/eshop/transport/PremiumType';
import { PaymentFrequencyStepSchema } from '@app/service/eshop/checkout/schemas/CheckoutStepSchema';
import { boolean, object } from 'yup';

export const PurchaseTransportInsuranceOfferStep = object({
    agreeToPrivacyPolicy: boolean().is([true], 'eshop.transport.validation.mustAcceptPrivacyPolicy'),
    agreeToMtplTerms: boolean().when('insurancePackage', {
        is: (insurancePackage: string) =>
            insurancePackage === PremiumType.Mtpl || insurancePackage === PremiumType.CascoMtpl,
        then: schema => schema.is([true], 'eshop.transport.validation.mustAcceptMtplTerms'),
        otherwise: schema => schema,
    }),
    agreeToCascoTerms: boolean().when('insurancePackage', {
        is: (insurancePackage: string) =>
            insurancePackage === PremiumType.Casco || insurancePackage === PremiumType.CascoMtpl,
        then: schema => schema.is([true], 'eshop.transport.validation.mustAcceptCascoTerms'),
        otherwise: schema => schema,
    }),
    agreeToDirectMarketingCompensa: boolean(),
    agreeToDirectMarketingCompensaLife: boolean(),
}).concat(PaymentFrequencyStepSchema);
